<template>
  <div>
    <el-button @click="batchDownloadAndZip" :loading="zipping">
      打包下载全部
    </el-button>
  </div>
</template>

<script>
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  data() {
    return {
      zipping: false,
      fileList: [{
            "url": "cloudexcel/excel/Temp/b059700d-7172-44ba-b186-5f6d32db02fb.xlsx",
            "name": "总部测试项目+2026-03-31",
            "status": 1
          },
          {
            "url": "cloudexcel/excel/Temp/33c56f0c-65d2-4cde-b8d8-5265056b67b2.xlsx",
            "name": "使用人数导出1.xlsx",
            "status": 1
          },
          {
            "url": "cloudexcel/excel/Temp/d7ca33bd-1620-4d82-a81e-3ad837760043.xlsx",
            "name": "使用人数导出2.xlsx",
            "status": 1
          },
          {
            "url": "cloudexcel/excel/Temp/5639afc4-e07e-4f30-a838-2fc030918729.xlsx",
            "name": "使用人数导出3.xlsx",
            "status": 1
          },
          {
            "url": "cloudexcel/excel/Temp/562f45d1-2f7e-4cab-b63f-003b630c2fac.xlsx",
            "name": "使用人数导出4.xlsx",
            "status": 1
          },
          {
            "url": "cloudexcel/excel/Temp/a5519f78-9d11-4305-afa0-b4e2cf1b9853.xlsx",
            "name": "使用人数导出5.xlsx",
            "status": 1
          },
          {
            "url": "clouddoc/DivorceNotice/c86df55a-0588-49b9-bfa6-e8e9b7329a98.docx",
            "name": "宁波英普瑞特供应链管理有限公司 - 20260310001.docx",
            "status": 1
          },
          {
            "url": "cloudexcel/excel/Temp/c58a700a-1dc1-4c3c-9d73-db77fe34f9eb.xlsx",
            "name": "已开票列表导出6.xlsx",
            "status": 1
          },
          {
            "url": "cloudexcel/excel/Temp/cc3d6354-0375-46f9-b38f-f7833ff2ca74.xlsx",
            "name": "已开票列表导出7.xlsx",
            "status": 1
          }
        ]
    }
  },
  methods: {
    async batchDownloadAndZip() {
      this.zipping = true
      const zip = new JSZip()
      
      try {
        // 并行下载所有文件
        const downloadPromises = this.fileList.map(async (file) => {
          const response = await fetch(file.url)
          const blob = await response.blob()
          return { name: file.name, blob }
        })
        
        const files = await Promise.all(downloadPromises)
        
        // 添加到 zip
        files.forEach(file => {
          zip.file(file.name, file.blob)
        })
        
        // 生成 zip 文件并下载
        const content = await zip.generateAsync({ type: 'blob' })
        saveAs(content, 'download.zip')
        
        this.$message.success('打包下载完成！')
      } catch (error) {
        console.error('打包失败:', error)
        this.$message.error('下载失败，请重试')
      } finally {
        this.zipping = false
      }
    }
  }
}
</script>